
const pbsPlugin = { 
    install(Vue, options) {

        // Function to save a data stream to file
        Vue.fileSave = function(datastream, filename) {

            var newBlob = new Blob([datastream], {type: 'application/octet-stream'})
            //var filename = item.id + "-" + item.internalRevision + ".ifc"

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob)
            var link = document.createElement('a')
            link.style.display = 'none'
            link.href = data
            link.setAttribute('download', filename);
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            setTimeout(() => {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data)
            }, 100)

        }


        // function to remove an object from an array based on 
        // an attributes value e.g. a users name, or email
        Vue.removeByAttr = function(arr, attr, value) {
            var i = arr.length
            while(i--){
            if( arr[i] 
                //&& arr[i].hasOwnProperty(attr) 
                && Object.prototype.hasOwnProperty.call(arr[i], attr)
                && (arguments.length > 2 && arr[i][attr] === value ) ){ 
                    arr.splice(i,1)
                } 
            }
            return arr
        },


        // function to find if an entry already exists in an array
        Vue.getIndexByAttr = function(arr, attr, value) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][attr] == value) {
                    return i
                }
            }
            return -1
        }

    }

}

export default pbsPlugin